import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { dollars } from 'utils/money';
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider';
import moment from 'moment';
import { startCase } from 'lodash';
import CircularProgress from '@material-ui/core/CircularProgress';
import { fetchApplications } from 'actions/applications';

const styles = theme => ({
  headerButton: {
    float: 'right'
  },
  flex: {
    flex: 1
  },
  spinnerWrapper: {
    height: '40px',
    position: 'absolute',
    left: '50%',
    top: '50%',
  }
});

class List extends React.Component {
  componentDidMount = () => {
    this.props.dispatch(fetchApplications());
  };

  renderSpinner = () => {
    if (this.props.showSpinner) {
      return (
        <div className={this.props.classes.spinnerWrapper}>
          <CircularProgress color='primary' thickness={9} />
        </div>
      );
    }
    return (<div className={this.props.classes.spinnerWrapper}></div>);
  }

  renderApplication = (application) => {
    const form = application.form
    return (
      <TableRow key={application.number}>
        <TableCell>
          <Link to={`/applications/${application.number}`}>
            {application.number}
          </Link>
        </TableCell>
        <TableCell>
          {
            application.organisation &&
              <Link to={`/organisations/${application.organisation.id}`}>
                {application.organisation.name}
              </Link>
          }
        </TableCell>
        <TableCell>
          {startCase(application.appType)}
        </TableCell>
        <TableCell>
          {startCase(application.status)}
        </TableCell>
        <TableCell>
          {moment(application.lodgedAt).format('DD/MM/YYYY')}
        </TableCell>
        <TableCell>
          {dollars(form.amount)}
        </TableCell>
        <TableCell>
          {form.termLength}
        </TableCell>
        <TableCell>
          {form.termUnit}
        </TableCell>
        <TableCell>
          {moment(form.drawdownDate).format('DD/MM/YYYY')}
        </TableCell>
      </TableRow>
    );
  }

  render = () => {
    const { applications, classes } = this.props;
    return (
      <div>
        { this.renderSpinner() }
        <div style={{ display: 'flex' }}>
          <Typography variant='headline' className={classes.flex}>
            Applications
          </Typography>
        </div>
        <Divider light />
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Number</TableCell>
              <TableCell>Org</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Lodgement Date</TableCell>
              <TableCell>Amount</TableCell>
              <TableCell>Term Length</TableCell>
              <TableCell>Term Unit</TableCell>
              <TableCell>Drawdown Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            { Object.values(applications).map(this.renderApplication) }
          </TableBody>
        </Table>
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  const { applications } = state;
  return { applications, showSpinner: state.app.showSpinner, };
};

const styled = withStyles(styles)(List)
const connected = connect(mapStateToProps)(styled);
export default connected;



// WEBPACK FOOTER //
// ./src/components/Applications/List.js